import { callZigzagFunction } from '../../callZigzagFunction';
import { SaveProduct } from '../../types';

// 최근 본 상품에 추가
export const abg = (saveProduct: SaveProduct) => {
  callZigzagFunction('abg')(saveProduct);
};
